<template>
  <div>
    <v-card>
      <v-toolbar flat v-if="meter !== null" height="90" outlined>
        <v-toolbar-title>
          <p
            class="subtitle-1 text-uppercase font-weight-bold ma-0 primary--text"
            style="white-space: normal"
          >
            <span v-if="prop === 'watts'">{{
              Math.abs(
                reading.lines.reduce((suma, l) => suma + l.watts, 0).toFixed(2)
              )
            }}</span>
            <span v-if="prop === 'amps'">{{
              Math.abs(
                reading.lines.reduce((suma, l) => suma + l.amps, 0).toFixed(2)
              )
            }}</span>
            <span v-if="prop === 'volts'">
              {{
                Object.entries(
                  reading.lines.reduce(
                    (acc, l) =>
                      l.volts > 10
                        ? (acc = {
                            suma: acc.suma + l.volts,
                            lines: acc.lines + 1,
                          })
                        : acc,
                    { suma: 0, lines: 0 }
                  )
                )
                  .reduce((total, el) => {
                    if (el[0] == "suma") return total + el[1];
                    else if (total == 0) return 0;
                    else return total / el[1];
                  }, 0)
                  .toFixed(2)
              }}
            </span>
          </p>
          <p class="caption ma-0" style="font-size: 10px !important">
            <span v-if="prop === 'watts'">POWER (WATTS)</span>
            <span v-if="prop === 'amps'">TOTAL CURRENT (AMPS)</span>
            <span v-if="prop === 'volts'">AVERAGE VOLTAGE (VOLTS)</span>
          </p>
        </v-toolbar-title>
      </v-toolbar>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "value",
  props: ["meter", "reading", "prop"],
};
</script>
